import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';

// MANAGERS
import { getCurrentGameState, getCurrentGameSubState } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';
import { StateManager } from '@Managers/StateManager/StateManager';

// CSS
import styles from './StateManagerView.scss';

// TYPES
import { EGameStates } from '@Managers/StateManager/GameStates';
import { ICurrentConditionItem, ICurrentSubConditionItem, IStateManagerState, RC_STATE_MANAGER_DEFAULTS } from './StateManagerView.types';

const StateManagerView: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: IStateManagerState, newState: {}) => ({ ...state, ...newState }), RC_STATE_MANAGER_DEFAULTS);

    const gameStates: Array<EGameStates> = Object.keys(EGameStates) as Array<EGameStates>;
    const gameStoreCurrentGameState = useAppSelector(getCurrentGameState);
    const gameStoreCurrentGameSubState = useAppSelector(getCurrentGameSubState);

    useEffect(() => {
        setState({
            statesEvents: StateManager.getStates()
        });
    }, []);

    useEffect(() => {
        const currentConditions: Array<ICurrentConditionItem> = [];

        state.statesEvents[gameStoreCurrentGameState]?.leaveConditions?.forEach((element, index) => {
            currentConditions.splice(index, 0, {
                name: element.name,
                resolved: 'false'
            });

            element.promise.then(() => {
                const array = state.currentCoditions;
                array.splice(index, 0, {
                    name: element.name,
                    resolved: 'true'
                });
                setState({ currentCoditions: array });
            });
        });

        setState({
            currentState: gameStoreCurrentGameState,
            currentCoditions: currentConditions
        });
    }, [gameStoreCurrentGameState]);

    useEffect(() => {
        const currentSubConditions: Array<ICurrentSubConditionItem> = [];
        const subStates = state.statesEvents[gameStoreCurrentGameState]?.subStates;

        if (subStates) {
            for (const [key, value] of Object.entries(subStates)) {
                const entry: { name: string }[] = [];
                const leave: { name: string; resolved: string }[] = [];

                value.entryConditions?.map((element, index) => {
                    entry.push({ name: element.name });
                });

                value.leaveConditions?.map((element, index) => {
                    leave.push({
                        name: element.name,
                        resolved: 'false'
                    });

                    element.promise.then(() => {
                        leave[leave.length - 1].resolved = 'true';
                    });
                });

                currentSubConditions.push({
                    name: key,
                    entry: entry,
                    leave: leave
                });
            }
        }

        setState({
            currentSubConditions: currentSubConditions
        });
    }, [gameStoreCurrentGameSubState]);

    return (
        <div className={styles.statemanager_container}>
            <div className={styles.statemanager_states}>
                <div className={styles.statemanager_header}>Main States</div>
                {gameStates.map((item: EGameStates, index: number) => {
                    return (
                        <div key={index} className={cn(styles.statemanager_state_item, item === state.currentState ? styles.active : null)}>
                            {item}
                        </div>
                    );
                })}
            </div>
            <div className={styles.statemanager_sub_states}>
                <div className={styles.statemanager_header}>Sub States</div>
                {state.currentSubConditions.map((element, index) => {
                    return (
                        <div className={styles.statemanager_substate_item} key={index}>
                            <div className={cn(styles.statemanager_substate_item_header, gameStoreCurrentGameSubState === element.name ? styles.active : null)}>
                                {element.name}
                            </div>
                            {element.entry.length > 0 && (
                                <div className={styles.statemanager_substate_item_condition_group}>
                                    <div className={styles.statemanager_substate_item_condition_header}>Entry:</div>
                                    {element.entry.map((element, index) => {
                                        return <div key={index}>{element.name}</div>;
                                    })}
                                </div>
                            )}

                            {element.leave.length > 0 && (
                                <div className={styles.statemanager_substate_item_condition_group}>
                                    <div className={styles.statemanager_substate_item_condition_header}>Leave:</div>
                                    {element.leave.map((element, index) => {
                                        return (
                                            <div key={index} className={styles.statemanager_substate_item_condition_item}>
                                                {element.name}: {element.resolved}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
            <div className={styles.statemanager_state_events}>
                <div className={styles.statemanager_header}>State Leave Conditions</div>
                {state.currentCoditions.map((element, index) => {
                    return (
                        <div className={styles.statemanager_events_key} key={index}>
                            {element.name} resolved:
                            <span className={cn(element.resolved === 'true' ? styles.con_true : styles.con_false)}> {element.resolved}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default StateManagerView;
